import { Col, Row } from 'antd';
import moment from 'moment';

import { IntervalPicker } from '@atoms/intervalPicker';
import { TSchedule, TScheduleTemplate } from '@components/schedule/common/types';

type TProps = {
    editing: boolean;
    breaks?: TSchedule['breaks'] | TScheduleTemplate['breaks'];
    onBreakDelete: (index: number) => void;
    tempBreak: { start_break_time?: Date; end_break_time?: Date };
    onTempBreakChange: (val: Date | null, target: 'start_break_time' | 'end_break_time') => void;
    tryAddBreak: (index: number, dates: moment.Moment[]) => void;
};

const ScheduleBreaks = ({
    editing,
    breaks,
    onBreakDelete,
    tempBreak,
    onTempBreakChange,
    tryAddBreak,
}: TProps): JSX.Element => {
    return (
        <Row className="vcentered">
            <Col style={{ minWidth: '120px' }}>
                <label>Перерывы</label>
            </Col>
            <Col>
                {breaks?.length == 0 && <i>Без перерывов</i>}
                <IntervalPicker
                    title="перерыв"
                    editing={editing}
                    breaks={breaks}
                    onBreakDelete={onBreakDelete}
                    tempBreak={tempBreak}
                    onTempBreakChange={onTempBreakChange}
                    tryAddBreak={tryAddBreak}
                />
            </Col>
        </Row>
    );
};

export { ScheduleBreaks };
